module.exports = __webpack_public_path__ + "static/speak-no-evil-36c64fb3983ad253ce827529fbbc98c0.jpg";